@if (event()) {
  <div
    libTippyTooltip
    [contentTemplate]="eventDetailsTpl"
    placement="bottom-start"
    trigger="manual"
    [showOnInit]="true"
    interactive
    [toolTipClass]="'bg-white w-100 rounded-lg p-lg flex flex-col gap-lg shadow-md'"
    class="absolute inset-0 pointer-events-none"
    aria-hidden="true"></div>

  <ng-template #eventDetailsTpl>
    <header class="flex items-center justify-between">
      <div class="flex items-center gap-sm">
        @if (event()?.source_type === CALENDAR_EVENT_SOURCE_TYPE.PROJECT) {
          <lib-repeat-icon iconClass="size-4 text-primary-500" />
        } @else {
          <lib-calendar-filled-icon iconClass="size-4 text-primary-500" />
        }

        <h6 class="text-neutral-900 font-semibold text-sm">
          {{ event()?.title }}
        </h6>
      </div>

      <button
        type="button"
        id="event_details_modal_close_button"
        (click)="handleCloseEventDetails()">
        <lib-close-icon iconClass="size-5 text-neutral-500" />
      </button>
    </header>

    <section id="attendee-container">
      <lib-user-dropdown-view
        [userTableList]="event()?.assignees || []"
        [userCount]="event()?.assignees?.length || 0"
        [userDropdownList]="event()?.assignees || []"
        [totalDropdownCount]="event()?.assignees?.length || 0"
        [headerListLabel]="'dropdown_search_find_assignees_label' | transloco"
        [searchLabel]="'dropdown_search_find_assignees_label' | transloco"
        [searchPlaceholder]="'search_by_name_placeholder' | transloco"
        [noSearchResultLabel]="'no_search_result_label' | transloco"
        [enableLocalSearch]="true"
        [containerRef]="'attendee-container'" />
    </section>

    <section class="flex flex-col gap-sm pb-lg border-b border-neutral-200">
      <div class="flex gap-sm">
        <lib-clock-icon iconClass="size-4 text-neutral-500" />

        <p class="text-neutral-700 text-xs font-normal">
          {{ occurrenceStart() | date: 'dd-MMM-yyyy hh:mm a' }} -
          {{ occurrenceEnd() | date: 'dd-MMM-yyyy hh:mm a' }}
        </p>
      </div>

      @if (event()?.details?.location_type) {
        <div class="flex gap-sm">
          <lib-tag-right-icon iconClass="size-4 text-neutral-500" />

          <p class="text-neutral-700 text-xs font-normal">
            {{ event()?.details?.location_type?.label || '' }}
          </p>
        </div>
      }

      @if (
        event()?.type &&
        event()?.source_type === CALENDAR_EVENT_SOURCE_TYPE.FLOW
      ) {
        <div class="flex gap-sm">
          <lib-tag-right-icon iconClass="size-4 text-neutral-500" />

          <p class="text-neutral-700 text-xs font-normal">
            {{ event()?.type?.label || '' }}
          </p>
        </div>
      }
    </section>

    <section class="flex items-center gap-sm">
      @if (event()?.note?.attachments?.length) {
        <div>
          <p class="view-mode-label">
            {{
              'event_details_attachments_section_attachments_title' | transloco
            }}
          </p>

          <lib-view-file
            [label]="''"
            [uploadedFiles]="event()?.note?.attachments || []"
            [uploadFileLabels]="{
              attachmentsTitle:
                'event_details_attachments_section_attachments_label'
                | transloco,
              singleFileUploadedLabel:
                'upload_files_single_file_uploaded_label' | transloco,
              multipleFilesUploadedLabel:
                'upload_files_multiple_files_uploaded_label' | transloco,
            }" />
        </div>
      }

      @if (event()?.details?.location) {
        <div>
          <p class="view-mode-label">
            {{ 'event_details_event_link_label' | transloco }}
          </p>

          @if (event()?.details?.location_type?.value === 'online') {
            <a
              class="view-mode-value break-word underline! text-primary-500"
              [href]="event()?.details?.location"
              target="_blank">
              {{ event()?.details?.location }}
            </a>
          } @else {
            <p class="view-mode-value break-word text-neutral-900">
              {{ event()?.details?.location }}
            </p>
          }
        </div>
      }

      @if (
        event()?.source_type === CALENDAR_EVENT_SOURCE_TYPE.FLOW &&
        event()?.source_id
      ) {
        <div>
          <p class="view-mode-label">
            {{ 'event_details_request_link_label' | transloco }}
          </p>

          <a
            class="view-mode-value break-word underline! text-primary-500"
            [href]="`${VIEW_EVENT_REQUEST_ROUTE}/${event()?.source_id}`"
            target="_blank"
            rel="noopener noreferrer">
            {{ event()?.source_id }}
          </a>
        </div>
      }
    </section>

    <section class="flex flex-col gap-x-sm">
      <h6 class="text-neutral-500 font-medium text-xs">
        {{ 'event_form_screen_agenda_label' | transloco }}
      </h6>

      <lib-long-text-view [content]="event()?.details?.agenda || ''" />
    </section>

    @if (eventActionsTemplate()) {
      <ng-container
        [ngTemplateOutlet]="eventActionsTemplate()"
        [ngTemplateOutletContext]="{ $implicit: event() }" />
    }
  </ng-template>
}
